import type { ReactNode } from 'react'
import { Component } from 'react'
import { ErrorFallback } from './error-fallback'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  reset = () => {
    this.setState({ error: null })
  }

  render(): ReactNode {
    if (this.state.error) {
      return this.props.fallback ?? <ErrorFallback error={this.state.error} onReset={this.reset} />
    }
    return this.props.children
  }
}
